import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Container, Button, Form, Row, Col, } from "react-bootstrap";
import { getNoTask } from './AllTaskSlice';
import Pagination from './Pagination'
import { AssignNoTaskModel } from './Model/AssignNoTaskModel';
import * as Icon from 'react-bootstrap-icons';
import useGetEmployees from './ReuseApi/useGetEmployees';
import ViewEmployeeFilter from './Filter/ViewEmployeeFilter';

const NoTask = () => {

    const dispatch = useDispatch()
    const loginUserData = useSelector((state) => state.loginData.userData);
    const NoTaskData = useSelector((state) => state.AllTasks.NoTask);
    const role = loginUserData?.resourceType;

    // for notaskmodel
    const [empId, setEmpId] = useState(null)
    const [shownotaskmodal, setShowNoTaskModal] = useState(false)
    const [notaskvalue, setNoTaskValue] = useState("")

    // call custom hook
    const { employeeOptions } = useGetEmployees();

    // for filter
    const [showFilter, setShowFilter] = useState(false)

    // for pagination state
    const [docsPerPage, setDocsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        getNoTaskData()
    }, [currentPage, docsPerPage])

    const getNoTaskData = (page = currentPage) => {
        const payload = {
            taskDate: "",
            lead: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
            empId: empId?.value || "",
            name: "",
            department: "",
            designation: "",
            documentsPerPage: docsPerPage,
            page: page
        }
        dispatch(getNoTask(payload))
    }


    //----- Pagination ---------------
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setCurrentPage(1)
        setDocsPerPage(docsPageProp);
    }

    // for model open and close function
    const handleShowNoTaskModal = (id) => {
        setNoTaskValue(id)
        setShowNoTaskModal(true)
    }
    const handleNoTaskModalClose = () => {
        setShowNoTaskModal(false)
        setNoTaskValue("")
        getNoTaskData()
    }

    const handleSearch = () => {
        setCurrentPage(1)
        getNoTaskData(1)
    }
    
    const handleClear = () => {
        setEmpId(null)
        setCurrentPage(1)
        dispatch(getNoTask({
            taskDate: "",
            lead: `${loginUserData?.firstName} ${loginUserData?.lastName}`,
            empId: "",
            name: "",
            department: "",
            designation: "",
            documentsPerPage: docsPerPage,
            page: currentPage
        }))
    }

    return (
        <div className='noTask outletPadding' data-aos="fade-up">
            <Container>
                <ViewEmployeeFilter
                    role={role}
                    employeeOptions={employeeOptions}
                    empId={empId}
                    setEmpId={setEmpId}
                    onSearch={handleSearch}
                    onClear={handleClear}
                />
                <AssignNoTaskModel show={shownotaskmodal} close={handleNoTaskModalClose} data={notaskvalue} userData={loginUserData} />
                <div className="outer-wrapper mx-auto">
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr >
                                    <th>Sr No</th>
                                    <th className='assignwidth1'>Employee ID</th>
                                    <th className='assignwidth1'>Name</th>
                                    <th className='assignwidth1'>Work Email</th>
                                    <th className='assignwidth1'>Designation</th>
                                    <th className='assignwidth1'>Department</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    NoTaskData?.data !== null &&
                                        NoTaskData?.data !== undefined &&
                                        NoTaskData?.data?.length > 0 ?
                                        NoTaskData?.data?.map((itm, index) => {
                                            const { firstName, lastName, workEmail, designation, department, contactNo, empId } = itm
                                            return (
                                                <tr key={Math.random() * 999999999}>
                                                    <td>{currentPage !== 1 ? (<> {index + 1 + 10 * (currentPage - 1)}</>) : <>{index + 1}</>}</td>
                                                    <td>{empId}</td>
                                                    <td>{firstName} {lastName}</td>
                                                    <td>{workEmail}</td>
                                                    <td>{designation}</td>
                                                    <td>
                                                        {department && Array.isArray(department) && department.map((row, index) => {
                                                            if (index === department.length - 1) {
                                                                return row.label;
                                                            } else {
                                                                return row.label + ', ';
                                                            }
                                                        })}
                                                        {/* {department && Array.isArray(department) && department.map((itm) => itm?.label)} */}
                                                    </td>
                                                    <td>
                                                        <div
                                                            data-toggle="modal">
                                                            <Button
                                                                className="primaryBtn my-1" style={{ padding: '4px 12px' }}
                                                                onClick={() => { handleShowNoTaskModal(itm) }}>
                                                                <Icon.PersonAdd className='me-2' />Assign
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr><td colSpan="18" className="text-center">No Data Available</td></tr>
                                }

                            </tbody>
                        </table>
                    </div>
                </div>

                <Row className='justify-content-end'>
                    <Pagination currentPage={currentPage} totalPages={NoTaskData?.noOfPages}
                        onPageChange={handlePageChange} onDocsPerPage={handleDocsPerPage} />
                </Row>
            </Container>

        </div>
    )
}

export default NoTask